























































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';

import {ApiStore} from '@/store/Api.store';
import NetworkSafeUpdateStore, {SaveState} from '@/store/network/NetworkSafeUpdate.store';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class SafeUpdateDialog extends Mixins<BaseComponent>(BaseComponent) {

  private SaveState = SaveState;

  private apiStore: ApiStore = getModule(ApiStore, this.$store);

  private safeUpdateStore: NetworkSafeUpdateStore = getModule(NetworkSafeUpdateStore, this.$store);

}

